module.exports = __webpack_public_path__ + "img/feature_timetable.44b46817.svg";